import React from 'react';
import {Row, Col} from 'reactstrap';
import PropertyItem from './PropertyItem';

const PropertyList = ({items, nodeId, values}) => (
    <Row className="property-list">
        {items.map(({id: propertyId, ...rest}) => (
            <Col key={propertyId} xs={12} sm={6} md={4} lg={3}>
                <PropertyItem nodeId={nodeId} propertyId={propertyId} value={values[`${nodeId}/${propertyId}`]} {...rest} />
            </Col>
        ))}
    </Row>
);

export default PropertyList;
